import React, { Component } from 'react'
import { connect } from 'react-redux'
class SingleItem extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false,
      updated: Date.now()
    }
    if (window.location.hash.indexOf(this.props.location) > -1 && this.props.sidebar) this.state.open = true
  }
  toggle () {
    if (!this.props.sidebar) {
      return
    }
    this.setState({
      open: !this.state.open
    })
  }
  render () {
    return (
      <ul className='menu-wrapper' onClick={() => (window.location.href = this.props.location)} >
        <li className={'menu-dropdown ' + (this.state.open ? 'active' : '')} onClick={this.toggle.bind(this)}>
          <i className={'fa fa-fw ' + (this.props.icon)} />
          <span className='menu-title'>{this.props.title}</span>
        </li>
      </ul>
    )
  }
}
// eslint-disable-next-line
SingleItem = connect(state => state.siteReducer)(SingleItem)
export default SingleItem



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/components/core/menu/SingleItem.js